import {
    GET_PHOTOS_LOADING,
    GET_PHOTOS_SUCCESS,
    GET_PHOTOS_FAILURE
} from '../../actions/types';

const INITIAL_STATE = {
    photos: {
        get: {
            loading: false,
            reset: false,
            success: {
                ok: false,
                data: null,
            },
            failure: {
                error: false,
                message: '',
            },
        }
    }
};

const photoReducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_PHOTOS_LOADING:
            return {
                ...state,
                photos: {
                    ...state.photos,
                    get: {
                        ...state.photos.get,
                        loading: true,
                        reset: false,
                        success: {
                            ...state.photos.get.success,
                            ok: false,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case GET_PHOTOS_SUCCESS:
            return {
                ...state,
                photos: {
                    ...state.photos,
                    get: {
                        ...state.photos.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.photos.get.success,
                            ok: true,
                            data: action.payload,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case GET_PHOTOS_FAILURE:
            return {
                ...state,
                photos: {
                    ...state.photos,
                    get: {
                        ...state.photos.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.photos.get.success,
                            ok: false,
                            data: null,
                        },
                        failure: {
                            error: true,
                            message: action.payload.message,
                        },
                    },
                },
            };
    }
    return state;
}

export default photoReducers;